<template>
    <div id="apiary-information-widget-component" class="position-relative">
        <div class="apiary-image-background-wrapper">
            <img class="apiary-image-background" src="images/widget/apiary_bee.png" />
        </div>

        <WidgetWrapperComponent :title="$t('global_apiary.local_vision')" id-widget="apiary-information-widget">
            <template v-slot:default>
                <p class="pt-2">Quelques informations renvoyées par votre rucher :</p>

                <div class="px-8 py-2 font-16">
                    <p class="font-weight-bold font-color-normal pb-2">Informations globales</p>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-trophy-outline</v-icon>
                            <span class="font-color-medium">Gain total</span>
                        </div>
                        <p class="font-weight-bold">{{ apiary.gain_total }}Kg</p>
                    </div>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-calendar-minus</v-icon>
                            <span class="font-color-medium">Gain semaine</span>
                        </div>
                        <p class="font-weight-bold">{{ (apiary.gain_total / 7).toFixed(2) }}Kg</p>
                    </div>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-shape-rectangle-plus</v-icon>
                            <span class="font-color-medium">Gain jour</span>
                        </div>
                        <p class="font-weight-bold">{{ (apiary.gain_total / 30).toFixed(2) }}Kg</p>
                    </div>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-scale-bathroom</v-icon>
                            <span class="font-color-medium">Poids net</span>
                        </div>
                        <p class="font-weight-bold">{{ apiary.net_weight_total }}Kg</p>
                    </div>

                    <p class="font-16 font-weight-bold font-color-normal pt-2">Informations complémentaires</p>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-water-outline</v-icon>
                            <span class="font-color-medium">Humidité</span>
                        </div>
                        <p class="font-weight-bold">{{ apiary.humidity_average }}%</p>
                    </div>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-thermometer</v-icon>
                            <span class="font-color-medium">Température</span>
                        </div>
                        <p class="font-weight-bold">{{ apiary.temperature_average }}°C</p>
                    </div>

                    <div class="d-flex justify-space-between w-40">
                        <div>
                            <v-icon class="pr-2">mdi-wifi</v-icon>
                            <span class="font-color-medium">Réception</span>
                        </div>

                        <div class="display-flex-content gap-1 line-height-16">
                            <v-icon
                                v-if="
                                    apiary.signal_quality_average === 0 ||
                                    apiary.signal_quality_average === 1 ||
                                    apiary.signal_quality_average === 2
                                "
                                color="error"
                                >mdi-network-strength-1-alert
                            </v-icon>

                            <v-icon v-else-if="apiary.signal_quality_average === 3" color="warning"> mdi-network-strength-3-alert </v-icon>

                            <v-icon v-else-if="apiary.signal_quality_average === 4" color="success">mdi-network-strength-3</v-icon>

                            <v-icon v-else-if="apiary.signal_quality_average === 5" color="success">mdi-network-strength-4</v-icon>
                        </div>
                    </div>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'

export default {
    name: 'ApiaryInformationWidgetComponent',
    components: { WidgetWrapperComponent },
    props: {
        apiary: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style>
.apiary-image-background-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 10;
    pointer-events: none;
}

.apiary-image-background {
    position: absolute;
    bottom: -30px;
    right: -14%;
    max-height: 400px;
    opacity: 50%;
}
</style>
